<template>
  <div>
    <v-container fluid justify-center fill-height align-center>
      <v-flex>
        <v-card class="elevetion-6">
          <v-toolbar dark class="elevation-0" color="primary" >
            <v-toolbar-title>Registration</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <new-form-interpritation
              v-if="getFormData"
              name="Blitz Registration"
              :formType="getFormData.type"
              :formId="getFormData.id"
              :formGroup="getFormData.group"
              :formFields="getFormData.fields"
              :formMetadata="getFormData.metadata"
              showSubmitButton
              @submit="onSubmit($event)"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NewFormInterpritation from './NewFormInterpritation'

export default {
  name: 'fake-form-registration',
  components: {
    NewFormInterpritation
  },
  computed: {
    ...mapGetters(['getFormData'])
  },
  methods: {
    ...mapActions(['getInterpritationFormData']),
    onSubmit (form) {
      console.log(form)
    }
  },
  created () {
    // blitz_registration
    this.getInterpritationFormData('blitz_registration')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/FakeBlitzRegistration/index.vue